module.exports = __webpack_public_path__ + "images/bg-modal-texture.442f21361f.svg";